import { inject } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, ContextStore } from 'bernie-core';
import { Layer } from 'bernie-view';

import { PropertyFilteredReviews } from '@shared-ui/lodging-reviews';
import { useLocalization } from '@shared-ui/localization-context';

import { adaptSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-criteria-adapter';
import { CurrentHotelStore } from 'stores/current-hotel-store';

import { ToolbarType, UitkToolbar, UitkToolbarProps } from 'uitk-react-toolbar';
import { UitkDialogContent, UitkFullscreenDialog } from 'uitk-react-dialog';

interface SharedUiPropertyReviewsDialogProps {
  currentHotel?: CurrentHotelStore;
  analytics?: AnalyticsStore;
  context?: ContextStore;
  onDialogClose: () => void;
}

/**
 * This component need a QueryRoute or DialogRoute,
 * if you need show and hide with a query param.
 */
export const SharedUiPropertyReviewsDialog: React.FC<SharedUiPropertyReviewsDialogProps> = inject(
  'analytics',
  'currentHotel',
  'context'
)(({ analytics, currentHotel, context, onDialogClose }) => {
  /* istanbul ignore next */
  const propertyId = currentHotel?.hotelId?.toString();
  const searchCriteria = adaptSearchCriteria(context, currentHotel.searchCriteria, false, null);

  const { formatText } = useLocalization();

  if (!propertyId) {
    return null;
  }

  /* istanbul ignore next */
  const isDated = currentHotel?.searchCriteria?.startDate?.length > 0;

  /* istanbul ignore next */
  const toolbarAnalytics = analytics?.setupTracker('ReviewsDialog', 'close reviews');
  const toolBarAttributes: UitkToolbarProps = {
    type: ToolbarType.CLOSE,
    header: formatText('hotels.infosite.reviews.title'),
    iconLabel: formatText('hotels.infosite.reviews.cancelButton.a11yLabel'),
    action: onDialogClose,
    analytics: toolbarAnalytics,
  };

  return (
    <Layer id="infosite-reviews">
      <UitkFullscreenDialog strictFullscreen={true} wideContent={true}>
        <UitkToolbar {...toolBarAttributes} />
        <UitkDialogContent>
          <PropertyFilteredReviews inputs={{ propertyId, searchCriteria, includeRecentReviews: isDated }} />
        </UitkDialogContent>
      </UitkFullscreenDialog>
    </Layer>
  );
});

SharedUiPropertyReviewsDialog.displayName = 'SharedUiPropertyReviewsDialog';
